import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";
import AboutMain from "../images/about/about-main.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();

  return (
    <>
      <section className="about-page">
        <HeroPages name={t('about.title')} />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={AboutMain}
              alt="expertise-service"
            />
            <div className="about-main__text">
              <h3>{t('about.companyTitle')}</h3>
              <h2>{t('about.subtitle')}</h2>
              <p>{t('about.description')}</p>
              <div className="about-main__text__icons">
                <div className="about-main__text__icons__box">
                  <img src={Box1} alt="car-icon" />
                  <span>
                    <h4>20</h4>
                    <p>{t('about.stats.vehicleTypes')}</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box2} alt="branch-icon" />
                  <span>
                    <h4>85</h4>
                    <p>{t('about.stats.branches')}</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box3} alt="service-icon" className="last-fk" />
                  <span>
                    <h4>75</h4>
                    <p>{t('about.stats.servicePoints')}</p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <PlanTrip />
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>{t('about.bookBanner.title')}</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3>{t('about.bookBanner.phone')}</h3>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
